import ApiService from '@/common/api.service';

const url = '/v1/limitations';

const LimitationService = {
  create(inventoryId, limitation) {
    return ApiService.post(url, {
      inventory_id: inventoryId,
      title: limitation.title,
      material: limitation.material,
      desc: limitation.desc
    });
  },
  update(id, limitation) {
    return ApiService.update(url, id, {
      title: limitation.title,
      material: limitation.material,
      desc: limitation.desc
    });
  },
  delete(id) {
    return ApiService.delete(`${url}/${id}`);
  }
};

export default LimitationService;
